export default [
  {
    title: 'Banner',
    customIcon: 'BannerSVG',
    children: [
      {
        title: 'Banner List',
        route: 'banner-list',
        path: '/banner/list/Banner_List',
      },
      {
        title: 'Banner Set List',
        route: 'set-banner',
        path: '/banner/set/Banner_Set',
      },
      {
        title: 'Banner Group List',
        route: 'banner-group',
        path: '/banner/group/Banner_Group',
      },
    ],
  },
];
